import Joi from '@hapi/joi'

export const VarianceSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Select Group Name`,
        "any.required": `Group Name characters`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory Name`,
        "any.required": `Factory Name characters`
    }),
    routeID: Joi.number().allow("",null).label("Route"),
    toDate: Joi.string().invalid("").label("Search Date")
}